function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M1.68421 2.5403C2.33823 2.5403 2.86842 2.01011 2.86842 1.35609C2.86842 0.702064 2.33823 0.171875 1.68421 0.171875C1.03019 0.171875 0.5 0.702064 0.5 1.35609C0.5 2.01011 1.03019 2.5403 1.68421 2.5403Z",
  fill: "#506383",
  fillOpacity: 0.25
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.702,
  d: "M9.05262 2.5403C9.70664 2.5403 10.2368 2.01011 10.2368 1.35609C10.2368 0.702064 9.70664 0.171875 9.05262 0.171875C8.3986 0.171875 7.86841 0.702064 7.86841 1.35609C7.86841 2.01011 8.3986 2.5403 9.05262 2.5403Z",
  fill: "#506383",
  fillOpacity: 0.25
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.401,
  d: "M16.421 2.5403C17.075 2.5403 17.6052 2.01011 17.6052 1.35609C17.6052 0.702064 17.075 0.171875 16.421 0.171875C15.767 0.171875 15.2368 0.702064 15.2368 1.35609C15.2368 2.01011 15.767 2.5403 16.421 2.5403Z",
  fill: "#506383",
  fillOpacity: 0.25
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.104,
  d: "M23.7894 2.5403C24.4435 2.5403 24.9736 2.01011 24.9736 1.35609C24.9736 0.702064 24.4435 0.171875 23.7894 0.171875C23.1354 0.171875 22.6052 0.702064 22.6052 1.35609C22.6052 2.01011 23.1354 2.5403 23.7894 2.5403Z",
  fill: "#506383",
  fillOpacity: 0.25
});

var SvgIconFlyingOneWayRight = function SvgIconFlyingOneWayRight(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 3,
    viewBox: "0 0 25 3",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconFlyingOneWayRight, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/IconFlyingOneWay_right.2e3c1f2a.svg";
export { ForwardRef as ReactComponent };